/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

const TextInput = ({
  validationFields,
  name,
  value,
  onChange,
  type,
  min,
  placeholder,
  max,
  pattern,
  required,
  validationMessages = { required: "This field is required" },
  disabled,
  confirmPassword,
  onKeyDown,
  isAutoFill = "on",
}) => {
  const [inputValue, setInputValue] = useState(value || "");
  const [intracted, setIntracted] = useState(false);
  const [currentValidationMessage, setCurrentValidationMessage] = useState(
    required ? "This field is required" : ""
  );

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (validateInput(newValue)) {
      onChange(newValue);
    }
  };
  const validateInput = (newValue) => {
    let isValid = true;
    let message = "";

    if (required && newValue === "") {
      isValid = false;
      message = validationMessages.required;
    } else if (type === "number") {
      if (!/^\d+$/.test(newValue)) {
        isValid = false;
        message = validationMessages.number || "Please enter a valid number";
      }
    } else if (type === "text") {
      if (!/^[A-Za-z\s]+$/.test(newValue)) {
        isValid = false;
        message = validationMessages.text || "Please enter a valid text";
      }
    } else if (type === "alphabet") {
      if (/[^A-Za-z]/g.test(newValue)) {
        isValid = false;
        message =
          validationMessages.alphabet ||
          "Please enter only alphabetic characters";
      }
    } else if (type === "email") {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(newValue)) {
        message =
          validationMessages.email || "Please enter a valid email address";
      }
    } else if (type === "phone") {
      if (!/^[0-9]{10}$/.test(newValue)) {
        message =
          validationMessages.phone || "Please enter a valid phone number";
      }
    } else if (type === "custom" && pattern) {
      const customRegex = new RegExp(pattern);
      if (!customRegex.test(newValue)) {
        isValid = false;
        message = validationMessages.custom || "Please enter a valid value";
      }
    }
    if (type === "between" && (min !== undefined || max !== undefined)) {
      const numericValue = parseFloat(newValue);
      const isNegativeNumber = /^-?\d*\.?\d*$/.test(newValue);

      if (
        !isNegativeNumber ||
        (min !== undefined && numericValue < min) ||
        (max !== undefined && numericValue > max)
      ) {
        isValid = false;
        message =
          validationMessages.between ||
          `Please enter a number between ${min} and ${max}`;
      }
    } else if (type === "password" && confirmPassword) {
      if (newValue !== confirmPassword) {
        message =
          validationMessages.passwordMismatch || "Passwords do not match";
      }
    }

    setCurrentValidationMessage(message);

    return isValid;
  };

  useEffect(() => {
    setInputValue(value || "");
    if (required && value && type !== "email" && type !== "phone") {
      setCurrentValidationMessage("");
    }
  }, [required, type, value]);
  return (
    <>
      <div className=" flex items-center gap-2">
        <input
          type={
            type === "password"
              ? "password"
              : type === "number" || type === "between"
              ? "number"
              : "text"
          }
          onKeyDown={onKeyDown}
          value={inputValue}
          onChange={handleChange}
          onFocus={() => {
            setIntracted(true);
          }}
          autoComplete={isAutoFill}
          onKeyPress={(e) => {
            if (!validateInput(inputValue + e.key)) {
              e.preventDefault();
            }
          }}
          disabled={disabled}
          className="border border-light-grey-500 rounded-md placeholder:text-medium-grey font-normal text-lg py-2 px-3 w-full focus:border-gray-500"
          placeholder={placeholder}
        />
        {/* <button >
          <img src='assets/search-alt-1-svgrepo-com.svg' alt='Search' />
        </button> */}
      </div>
      {required && inputValue === "" && (
        <p className="mt-2 text-red-500 text-xs">
          {validationMessages.required || "This Field is Required"}
        </p>
      )}
    </>
  );
};

export default TextInput;
